import React from "react";
import { motion } from "framer-motion";
import { CloudUploadOutlined } from "@ant-design/icons";
import { askAiTokens as t } from "./tokens";
import { MAX_FILE_SIZE_MB } from "./fileUtils";

interface Props {
  visible: boolean;
}

const DropZoneOverlay: React.FC<Props> = ({ visible }) => {
  if (!visible) return null;
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.15 }}
      style={{
        position: "absolute",
        inset: 0,
        background: "rgba(255, 255, 255, 0.92)",
        border: `2px dashed ${t.color.accent}`,
        borderRadius: t.radius.lg,
        zIndex: 20,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "none",
        gap: t.space.s3,
      }}
    >
      <CloudUploadOutlined style={{ fontSize: 42, color: t.color.accent }} />
      <div
        style={{
          fontSize: t.font.size.lg,
          fontWeight: 600,
          color: t.color.text,
        }}
      >
        Drop to attach
      </div>
      <div
        style={{
          fontSize: t.font.size.sm,
          color: t.color.textMuted,
        }}
      >
        PDF, DOC, XLS, CSV, TXT, PNG, JPG · up to {MAX_FILE_SIZE_MB} MB each
      </div>
    </motion.div>
  );
};

export default DropZoneOverlay;
